<template>
  <div class="wx-button-wrapper" @click="handleClick">
    <!--suppress HtmlUnknownTag -->
    <wx-open-launch-weapp v-if="canGoMp" ref="openBtn" class="wx-open-launch-weapp" :username="username" :path="path">
      <!-- 必须写：占位的按钮 -->
      <script type="text/wxtag-template">
        <style>
          .ctn {
            width: 80px;
            height: 87px;
          }
        </style>
        <div class="ctn"></div>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>

<script>
import { isWeChat } from '@/utils/getSystemIno'
import { mapMutations } from 'vuex'

export default {
  name: 'PavilionButton',
  props: {
    toMp: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/pages/index/index.html'
    },
    username: {
      type: String,
      default: ''
    }
  },
  computed: {
    canGoMp () {
      return this.toMp && this.username && isWeChat()
    }
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast'
    }),
    handleClick () {
      if (this.toMp && !isWeChat()) {
        this.toast('请在微信中打开此链接')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wx-open-launch-weapp {
  z-index: 2;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  // background: transparent;
}

.wx-button-wrapper {
  z-index: 2;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  // background: transparent;
}
</style>
